// extracted by mini-css-extract-plugin
export default {"marginTop":"Error404Page_marginTop__VZXjP","errorBox":"Error404Page_errorBox__Z9yKI","link":"Error404Page_link__vZZOQ"};